import { memo } from "react";
import AdminBreadcrumb from "@/features/admin/components/AdminBreadcrumb";
import TeamNavigation from "../TeamManagement/TeamNavigation";
import TeamFilter from "../TeamManagement/TeamFilter";
import HashKeysLoadingSkeleton from "./HashKeysLoadingSkeleton";
import Navbar from "@/components/Common/Navbar";
import type { SortOption } from "@/features/auth/types/hashKeys.types";

interface HashKeysLoadingStateProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: SortOption;
  setSortBy: (sort: SortOption) => void;
}

/**
 * Loading state component for hash keys management
 */
const HashKeysLoadingState = memo<HashKeysLoadingStateProps>(
  ({ searchQuery, setSearchQuery, sortBy, setSortBy }) => (
    <main className="scrollbar-thin flex h-screen min-h-0 flex-1 flex-col gap-7 overflow-y-auto p-3 px-4 pr-0 pl-6 transition-all duration-300">
      <div className="mb-5 flex-shrink-0">
        <Navbar subtitle="manager" />
      </div>

      {/* Fixed Header */}
      <div className="flex-shrink-0 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <div className="flex md:flex-col md:gap-4 lg:flex-row lg:items-center lg:justify-between">
          <AdminBreadcrumb title="Team Management" />
          <TeamNavigation
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>
      </div>

      <div className="min-h-0 flex-1 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <div className="flex min-h-0 w-full flex-row justify-start gap-8 pb-20">
          <div className="flex w-full justify-between gap-8 md:flex-col-reverse lg:flex-col-reverse xl:flex-row">
            {/* Action buttons skeleton */}
            <div className="flex w-auto flex-row gap-2">
              <div className="h-[52px] w-32 animate-pulse rounded bg-gray-300" />
              <div className="h-[52px] w-24 animate-pulse rounded bg-gray-300" />
            </div>

            {/* Main content skeleton */}
            <div className="w-full">
              <HashKeysLoadingSkeleton />
            </div>

            {/* Filter sidebar skeleton */}
            <TeamFilter
              sortBy={sortBy}
              onSortChange={(value: string) => setSortBy(value as SortOption)}
              filterRole="all"
              onFilterChange={() => {}}
              roleCounts={{}}
              totalMembers={0}
            />
          </div>
        </div>
      </div>
    </main>
  ),
);

HashKeysLoadingState.displayName = "HashKeysLoadingState";

export default HashKeysLoadingState;
